// extracted by mini-css-extract-plugin
module.exports = {"bestMatch":"top_bestMatch_3redy","title":"top_title_2repx"};